import type { AlienFaqEntry } from './types';

export const alienInvasionFaq: AlienFaqEntry[] = [
  {
    "id": "ai:faq:base-rules",
    "scenarioId": "all",
    "question": "Czy nadal obowiązują zasady podstawowe ON MARS?",
    "answer": "Tak. Wszystkie zasady podstawowe obowiązują, o ile aktywny rozdział wyraźnie ich nie zmienia."
  },
  {
    "id": "ai:faq:combine",
    "scenarioId": "all",
    "question": "Czy można łączyć kilka rozdziałów?",
    "answer": "Nie. Każdy rozdział jest osobnym trybem i używa własnego zestawu reguł i komponentów."
  },
  {
    "id": "ai:faq:order",
    "scenarioId": "all",
    "question": "Czy trzeba grać rozdziały w kolejności?",
    "answer": "Nie. Kolejność zachowuje fabułę, ale scenariusze są mechanicznie niezależne."
  },
  {
    "id": "ai:faq:invasion-end",
    "scenarioId": "invasion",
    "question": "Czy w Invasion wykonuje się punktację końcową?",
    "answer": "Nie. Zwycięstwo obu stron jest natychmiastowe."
  },
  {
    "id": "ai:faq:outbreak-cost",
    "scenarioId": "outbreak",
    "question": "Czy zakażony kolonista zwiększa koszt pola akcji?",
    "answer": "Tak. Zakażony kolonista nadal liczy się przy dodatkowym koszcie czerwonych pól akcji."
  },
  {
    "id": "ai:faq:blackout-vandalized",
    "scenarioId": "blackout",
    "question": "Czy zdewastowany budynek nadal działa?",
    "answer": "Tak. Dopiero budynek w blackout z leżącym kolonistą przestaje działać."
  },
  {
    "id": "ai:faq:monolith-lacerda",
    "scenarioId": "monolith",
    "question": "Czy w Monolith używa się Lacerda-bota?",
    "answer": "Nie. Monolith ma własny system solo i talię sabotażu."
  }
];
